module.exports = __webpack_public_path__ + "static/Lucas_Logo_Sve-249cb6e64d05eb7181d30ad62977745c.svg";